const indexItems = [
  { title: '探花精选合集', count: '428', tag: 'hot' },
  { title: '经典回顾系列', count: '315', tag: '' },
  { title: '最新上架内容', count: '267', tag: 'new' },
  { title: '稀有珍藏资源', count: '189', tag: 'rare' },
  { title: '高人气推荐', count: '203', tag: '' },
  { title: '独家策划专题', count: '156', tag: 'exclusive' },
  { title: '每周精选汇总', count: '134', tag: '' },
  { title: '新人专区导航', count: '112', tag: 'new' },
  { title: '探花全部分类', count: '1,820', tag: '' },
];

export default function IndexSection() {
  return (
    <section id="index" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            主题索引
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
            {indexItems.map((item) => (
              <a
                key={item.title}
                href="#index"
                onClick={(e) => e.preventDefault()}
                className="flex flex-col items-center justify-center p-4 bg-background-100 rounded-lg border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer group text-center"
              >
                <div className="flex items-center gap-1.5 mb-2">
                  <span className="font-heading text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">{item.title}</span>
                  {item.tag === 'hot' && <span className="px-1 py-0.5 text-[9px] font-bold text-accent-600 bg-accent-100 rounded-full">热</span>}
                  {item.tag === 'new' && <span className="px-1 py-0.5 text-[9px] font-bold text-secondary-600 bg-secondary-100 rounded-full">新</span>}
                  {item.tag === 'rare' && <span className="px-1 py-0.5 text-[9px] font-bold text-primary-600 bg-primary-100 rounded-full">稀有</span>}
                  {item.tag === 'exclusive' && <span className="px-1 py-0.5 text-[9px] font-bold text-accent-600 bg-accent-100 rounded-full">独家</span>}
                </div>
                <span className="text-xs text-foreground-400">{item.count} 项</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}